'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUserFn = exports.isUserSubscriptionAdmin = exports.isSubscriptionManuallyCreated = exports.isSubscribed = exports.isGuest = exports.isStaff = exports.isAdmin = exports.isOnline = exports.getInitials = exports.getDisplayName = undefined;

var _immutableHelper = require('../../common/utils/immutableHelper');

var _userConstants = require('../../common/users/userConstants');

var getDisplayName = exports.getDisplayName = function getDisplayName(user) {
    var name = user.getIn(['name', 'displayName']);

    var givenName = user.getIn(['name', 'givenName']);
    var familyName = user.getIn(['name', 'familyName']);
    if (!name && givenName) {
        name = givenName + ' ' + familyName;
    } else if (!name) {
        name = user.get('email');
    } else if (!name) {
        name = 'Unknown user';
    }

    return name;
};

// Constants
var getInitials = exports.getInitials = function getInitials(user) {
    var givenName = user.getIn(['name', 'givenName']);
    var familyName = user.getIn(['name', 'familyName']);

    if (!givenName || !familyName) {
        return '•••';
    }

    return givenName[0] + familyName[0];
};

var isOnline = exports.isOnline = function isOnline(user) {
    return user && user.get('onlineStatus') === _userConstants.USER_ONLINE_STATUS.CONNECTED;
};

var isAdmin = exports.isAdmin = function isAdmin(user) {
    return user && user.get('role') === _userConstants.USER_ROLES.ADMIN;
};

var isStaff = exports.isStaff = function isStaff(user) {
    return user && user.get('role') === _userConstants.USER_ROLES.STAFF || isAdmin(user);
};

var isGuest = exports.isGuest = function isGuest(user) {
    return !user || user.get('isGuest');
};

var isSubscribed = exports.isSubscribed = function isSubscribed(user) {
    return (0, _immutableHelper.propIn)(['subscription', 'active'], user);
};
var isSubscriptionManuallyCreated = exports.isSubscriptionManuallyCreated = function isSubscriptionManuallyCreated(user) {
    return user && user.getIn(['subscription', 'manuallyCreated']);
};
var isUserSubscriptionAdmin = exports.isUserSubscriptionAdmin = function isUserSubscriptionAdmin(user, subscription) {
    return user && subscription && user.get('_id') === subscription.get('adminId');
};

var getUserFn = exports.getUserFn = function getUserFn(userList) {
    return function (id) {
        return userList.get(id);
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/userUtil.js
// module id = 31
// module chunks = 0